import { withStyles, Box, Button, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    active: {
        zIndex: 10,
        border: "1px solid #ADADAD",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    },
    expandable: {
        position: "relative",
        maxWidth: "200px",
        cursor: "pointer",
        padding: "0 8px",
        borderRadius: "4px",
        fontSize: 14,
        "&:hover": {
            background: "rgba(0,0,0,0.1)",
        },
    },
    expandableBackground: {
        background: "rgba(0,0,0,0.1)",
    },
    loader: {
        minHeight: "33px",
        maxWidth: "200px",
        width: "100%",
    },
    expandableBody: {
        width: "100%",
        boxSizing: "border-box",
        position: "absolute",
        left: 0,
        boxShadow: "none",
        textTransform: "none",
        fontSize: 14,
        lineHeight: 1.5,
        borderRadius: "6px",
        backgroundColor: "#fff",
        padding: "0 12px",
        top: ({ expandOnTop }) => (expandOnTop ? "unset" : "30px"),
        bottom: ({ expandOnTop }) => (expandOnTop ? "110%" : "unset"),
        "& > *": {
            padding: "6px 0",
            cursor: "pointer",
        },
        "& > * + *": {
            borderTop: "1px solid #D8D8D8",
        },
        [theme.breakpoints.down("md")]: {
            width: "300px",
            right: 0,
            left: "unset",
        },
    },
    hover: {
        "&:hover": {
            backgroundColor: "rgba(0,0,0,0.1)",
        },
    },
}));

export const ContainedButton = withStyles({
    root: {
        boxShadow: "none",
        textTransform: "none",
        fontSize: 14,
        padding: "6px 12px",
        lineHeight: 1.5,
        border: "0.5px solid #F56921",
        background: "#FEE8DC",
        width: "200px",
        color: "transparent",
        textShadow: "0 0 0 #F56921",
        "&:hover": {
            boxShadow: "none",
            borderColor: "rgba(245, 105, 33, 0.6)",
        },
        "&:active": {
            boxShadow: "none",
            borderColor: "rgba(245, 105, 33, 0.6)",
        },
    },
})(Button);

export const PrimaryActionLabel = withStyles({
    root: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        wordBreak: "break-word",
        "& span": {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        },
    },
})(Box);
